import React from "react";
import { PenTool } from "lucide-react";

export default function SignatureForm({ signature, setSignature }) {
  const s = signature || {};
  const set = (k, v) => setSignature({ ...s, [k]: v });
  const previewLine = s.firma_testo?.trim()
    ? s.firma_testo
    : `Firmato digitalmente da Dott${s.qualifica && s.qualifica.toLowerCase().includes("essa") ? "" : "."} ${s.full_name || "—"}${s.qualifica ? " - " + s.qualifica : ""}${s.albo_numero ? " - Iscrizione Ordine n. " + s.albo_numero : ""}${s.albo_provincia ? " (" + s.albo_provincia + ")" : ""}`;

  return (
    <div className="space-y-4" data-testid="signature-form">
      <div className="flex items-center gap-2 mb-1">
        <PenTool className="text-brand-azure" size={16} />
        <h4 className="font-extrabold text-brand-navy text-sm">Firma e dati professionali</h4>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Nome e Cognome</label>
          <input
            data-testid="sig-full-name"
            value={s.full_name || ""}
            onChange={(e) => set("full_name", e.target.value)}
            placeholder="Es. Piera Giordano"
            className="mt-1 w-full px-3 py-2 rounded-lg border border-[#E2E8F0] focus:outline-none focus:border-brand-azure text-sm"
          />
        </div>
        <div>
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Qualifica</label>
          <input
            data-testid="sig-qualifica"
            value={s.qualifica || ""}
            onChange={(e) => set("qualifica", e.target.value)}
            placeholder="Oculista"
            className="mt-1 w-full px-3 py-2 rounded-lg border border-[#E2E8F0] focus:outline-none focus:border-brand-azure text-sm"
          />
        </div>
        <div>
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Numero iscrizione Ordine</label>
          <input
            data-testid="sig-albo-num"
            value={s.albo_numero || ""}
            onChange={(e) => set("albo_numero", e.target.value)}
            placeholder="Es. 12345"
            className="mt-1 w-full px-3 py-2 rounded-lg border border-[#E2E8F0] focus:outline-none focus:border-brand-azure text-sm"
          />
        </div>
        <div>
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Provincia / Ordine di appartenenza</label>
          <input
            data-testid="sig-albo-prov"
            value={s.albo_provincia || ""}
            onChange={(e) => set("albo_provincia", e.target.value)}
            placeholder="Es. MI"
            className="mt-1 w-full px-3 py-2 rounded-lg border border-[#E2E8F0] focus:outline-none focus:border-brand-azure text-sm"
          />
        </div>
      </div>
      <div>
        <label className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Testo firma personalizzato (opzionale)</label>
        <textarea
          data-testid="sig-firma-testo"
          rows={2}
          value={s.firma_testo || ""}
          onChange={(e) => set("firma_testo", e.target.value)}
          placeholder='Es. "Firmato digitalmente da Dott.ssa Piera Giordano - Oculista - Iscrizione Ordine n. 12345 (MI)"'
          className="mt-1 w-full px-3 py-2 rounded-lg border border-[#E2E8F0] focus:outline-none focus:border-brand-azure text-sm"
        />
        <div className="text-[10px] text-slate-500 mt-1 italic">Se lasciato vuoto, il testo viene generato automaticamente dai campi sopra.</div>
      </div>
      <div className="bg-slate-50 border border-dashed border-slate-300 rounded-lg p-3">
        <div className="text-[10px] font-bold uppercase tracking-wider text-slate-500 mb-1">Anteprima firma in fondo al referto/PDF</div>
        <div className="text-sm text-brand-navy font-semibold" data-testid="sig-preview">{previewLine}</div>
      </div>
    </div>
  );
}
